<template>
  <div class="view-active-campaign">
    <h4 class="text-semibold mb-5">Active Campaign</h4>
    <snow-data-table-header
      class="mb-6"
      @add="modal = true"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!providers.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-4 d-flex flex-column align-items-center gap-4">
            <h2 class="text-semibold">Ainda não há nada aqui</h2>
            <img src="@/assets/images/no-content.svg" />
            <h3>Talvez você precise</h3>
            <snow-button
              text="Integrar sua conta"
              icon="ph ph-plus"
              @click="modal = true"
            />
            <h5 class="text-dark-40">
              Integre sua conta de e-mail marketing para garantir um perfeito
              fluxo de disparos para seus clientes
            </h5>
          </div>
        </div>
      </div>
      <snow-data-table v-else :data="providers" :columns="columns" />
      <div class="d-flex justify-content-end">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <active-campaign-modal
      v-model="modal"
      :editedProvider="editedProvider"
      @clear-edit="editedProvider = null"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import ActiveCampaignModal from "@/components/tools/modals/ActiveCampaign";
import { mapState } from "vuex";

export default {
  components: {
    ActiveCampaignModal
  },
  data() {
    return {
      loading: false,
      editedProvider: null,
      modal: false,
      product_id: null,
      page: 1,
      search: ""
    };
  },
  mounted() {
    this.dispatch();
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["providers", "mapProviderName", "pagination"])
  },
  methods: {
    columns() {
      return [
        {
          name: "Descrição",
          field: "description"
        },
        {
          name: "Nome da conta",
          field: "name",
          transform: v => this.mapProviderName[v]
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          color: v => (v ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: [
            {
              label: "Editar",
              click: this.edit
            },
            {
              label: "Excluir",
              class: "text-danger",
              variant: "danger",
              dialog: {
                text:
                  "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação.",
                buttonText: "Sim, excluir",
                action: this.submitDelete,
                secondaryButtonText: "Não, cancelar",
                icon: "ph ph-trash"
              }
            }
          ]
        }
      ];
    },
    searching(search) {
      this.search = search;
      this.dispatch();
    },
    dispatch() {
      let params = {
        name: "active_campaign"
      };

      if (this.search) {
        params = { search: this.search };
      }

      this.loading = true;
      this.$store
        .dispatch("integration/getProviders", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.editedProvider = null;
          this.loading = false;
        });
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteProvider", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível deletar a conta integrada");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(v) {
      this.editedProvider = v;
      this.modal = true;
    },
    refresh() {
      this.dispatch();
    }
  }
};
</script>
